//@ts-ignore
import React, { FC } from 'react';
import { CloseButton } from './CloseButton';
import FullscreenButton from './FullscreenButton';
import { ButtonsBarProps } from './types';

export const ButtonsBar: FC<ButtonsBarProps & { children?: any }> = ({
  isFullScreen,
  toggleFullscreen,
  closePopup,
}) => (
  <>
    <CloseButton onClick={closePopup} isFullscreen={isFullScreen} />
    <FullscreenButton onClick={toggleFullscreen} isFullscreen={isFullScreen} />
  </>
);
